import { rejectRefreshToken } from './rejectRefreshToken';
import { setTokenLocalStorage } from './setTokenLocalStorage';
import { configRetryRefresh, isCancel } from 'core/api/baseApi';
import { change_auth_domain_api } from 'core/api/change_api_domain';

export const interceptorsResponseSuccess = (config) => {
    setTokenLocalStorage(config);

    if (!config?.config?.url?.includes('auth/refresh')) {
        configRetryRefresh.count = 0;
    }

    return config;
};

export const interceptorsResponseError = async (error) => {
    if (error.config?.enabledChangeDomainApi && !isCancel(error) && !error.response) {
        return change_auth_domain_api.initNextDomain(error);
    }

    return rejectRefreshToken(error);
};
